module.exports = __webpack_public_path__ + "img/DigitalAlbum2.00a8b664.jpg";